<template>
  <div class="wdhq-wrapper">
    <div class="hq-top-wrapper xflex xflex-col">
      <div class="hq-top-sell xflex xflex-col xflex-j-s">
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            涨停
          </div>
          <div class="sell-item-price" :style="{ color: Number(upperlimit) ? Color(pp, Number(upperlimit)) : '#666' }">
            {{ Number(upperlimit) ? upperlimit : '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            卖五
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(sellLevels[4].price) ? Color(pp, Number(sellLevels[4].price)) : '#666' }">
            {{ Number(sellLevels[4].price) ? sellLevels[4].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ sellLevels[4] ? formatNumUnit(sellLevels[4].volume) : '--' }}

          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            卖四
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(sellLevels[3].price) ? Color(pp, Number(sellLevels[3].price)) : '#666' }">
            {{ Number(sellLevels[3].price) ? sellLevels[3].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ sellLevels[3] ? formatNumUnit(sellLevels[3].volume) : '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            卖三
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(sellLevels[2].price) ? Color(pp, Number(sellLevels[2].price)) : '#666' }">
            {{ Number(sellLevels[2].price) ? sellLevels[2].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ sellLevels[2] ? formatNumUnit(sellLevels[2].volume) : '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            卖二
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(sellLevels[1].price) ? Color(pp, Number(sellLevels[1].price)) : '#666' }">
            {{ Number(sellLevels[1].price) ? sellLevels[1].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ sellLevels[1] ? formatNumUnit(sellLevels[1].volume) : '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            卖一
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(sellLevels[0].price) ? Color(pp, Number(sellLevels[0].price)) : '#666' }">
            {{ Number(sellLevels[0].price) ? sellLevels[0].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ sellLevels[0] ? formatNumUnit(sellLevels[0].volume) : '--' }}
          </div>
        </div>

      </div>
      <div class="line">
        <div class="line1" :style="{ width: buysellPer }">
        </div>
      </div>
      <div class="hq-top-sell xflex xflex-col xflex-j-s">
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            买一
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(buyLevels[0].price) ? Color(pp, buyLevels[0].price) : '#666' }">
            {{ Number(buyLevels[0].price) ? buyLevels[0].price :
              '--' }}
          </div>
          <div class="sell-item-amount">
            {{ buyLevels[0] ? formatNumUnit(buyLevels[0].volume) :
              '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            买二
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(buyLevels[1].price) ? Color(pp, buyLevels[1].price) : '#666' }">
            {{ Number(buyLevels[1].price) ?
              buyLevels[1].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ buyLevels[1] ?
              formatNumUnit(buyLevels[1].volume) : '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            买三
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(buyLevels[2].price) ? Color(pp, buyLevels[2].price) : '#666' }">
            {{ Number(buyLevels[2].price) ?
              buyLevels[2].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ buyLevels[2] ?
              formatNumUnit(buyLevels[2].volume) :
              '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            买四
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(buyLevels[3].price) ? Color(pp, buyLevels[3].price) : '#666' }">
            {{ Number(buyLevels[3].price) ?
              buyLevels[3].price : '--' }}
          </div>
          <div class="sell-item-amount">
            {{ buyLevels[3] ?
              formatNumUnit(buyLevels[3].volume)
              : '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            买五
          </div>
          <div class="sell-item-price"
            :style="{ color: Number(buyLevels[4].price) ? Color(pp, buyLevels[4].price) : '#666' }">
            {{
              Number(buyLevels[4].price)
              ? buyLevels[4].price :
              '--' }}
          </div>
          <div class="sell-item-amount">
            {{ buyLevels[4] ?
              formatNumUnit(buyLevels[4].volume)
              : '--' }}
          </div>
        </div>
        <div class="sell-item xflex ">
          <div class="sell-item-text">
            跌停
          </div>
          <div class="sell-item-price" :style="{ color: Number(lowerlimit) ? Color(pp, Number(lowerlimit)) : '#666' }">
            {{
              Number(lowerlimit)
              ? lowerlimit :
              '--' }}
          </div>
        </div>

      </div>
    </div>
    <div class="hq-bottom-wrapper xflex xflex-col" style="display: none;">
      <div class="hq-bottom-title">
        <span>分时成交</span>
        <span class=""></span>
      </div>
      <div class="hq-bottom-item-wrapper xflex-1 xflex xflex-col xflex-j-s ">

        <div class="hq-bottom-item xflex" v-for="(item, index) in tickList" :key="index">
          <div class="hq-bottom-item-time">
            {{
              item ?
              item[7]
              : '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, item ? item[1] : 0.00) }">
            <div class="price">
              {{
                item
                ?
                toDecimal(item[1])
                :
                0.00
              }}

            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              item
              ?
              formatNumUnit(item[3])
              :
              0
            }}
          </div>
        </div>
      </div>
      <div class="hq-bottom-item-wrapper xflex-1 xflex xflex-col xflex-j-s" style="display: none;">
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[0]
              ?
              tickList[0][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[0] ? tickList[0][1] : 0.00) }">
            <div class="price">
              {{
                tickList[0]
                ?
                toDecimal(tickList[0][1])
                :
                0.00
              }}

            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[0]
              ?
              formatNumUnit(tickList[0][3])
              :
              0
            }}
          </div>
        </div>
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[1]
              ?
              tickList[1][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[1] ? tickList[1][1] : 0.00) }">
            <div class="price">
              {{
                tickList[1]
                ?
                toDecimal(tickList[1][1])
                :
                0.00
              }}
            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[1]
              ?
              formatNumUnit(tickList[1][3])
              :
              0
            }}
          </div>
        </div>
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[2]
              ?
              tickList[2][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[2] ? tickList[2][1] : 0.00) }">
            <div class="price">
              {{
                tickList[2]
                ?
                toDecimal(tickList[2][1])
                :
                0.00
              }}
            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[2]
              ?
              formatNumUnit(tickList[2][3])
              :
              0
            }}
          </div>
        </div>
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[3]
              ?
              tickList[3][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[3] ? tickList[3][1] : 0.00) }">
            <div class="price">
              {{
                tickList[3]
                ?
                toDecimal(tickList[3][1])
                :
                0.00
              }}
            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[3]
              ?
              formatNumUnit(tickList[3][3])
              :
              0
            }}
          </div>
        </div>
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[4]
              ?
              tickList[4][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[4] ? tickList[4][1] : 0.00) }">
            <div class="price">
              {{
                tickList[4]
                ?
                toDecimal(tickList[4][1])
                :
                0.00
              }}
            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[4]
              ?
              formatNumUnit(tickList[4][3])
              :
              0
            }}
          </div>
        </div>
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[5]
              ?
              tickList[5][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[5] ? tickList[5][1] : 0.00) }">
            <div class="price">
              {{
                tickList[5]
                ?
                toDecimal(tickList[5][1])
                :
                0.00
              }}
            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[5]
              ?
              formatNumUnit(tickList[5][3])
              :
              0.00
            }}
          </div>
        </div>
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[6]
              ?
              tickList[6][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[6] ? tickList[6][1] : 0.00) }">
            <div class="price">
              {{
                tickList[6]
                ?
                toDecimal(tickList[6][1])
                :
                0.00
              }}
            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[6]
              ?
              formatNumUnit(tickList[6][3])
              :
              0.00
            }}
          </div>
        </div>
        <div class="hq-bottom-item xflex">
          <div class="hq-bottom-item-time">
            {{
              tickList[7]
              ?
              tickList[7][7]
              :
              '--'
            }}
          </div>
          <div class="hq-bottom-item-price xflex" :style="{ color: Color(pp, tickList[7] ? tickList[7][1] : 0.00) }">
            <div class="price">
              {{
                tickList[7]
                ?
                toDecimal(tickList[7][1])
                :
                0.00
              }}
            </div>
            <!-- <div v-if="Color(0, tickList[0] ? tickList[0][1] : 0.00) === '#CC0000'">
              &#8593;
            </div>
            <div class="" v-else>
              &#8595;
            </div> -->
          </div>
          <div class="hq-bottom-item-amount">
            {{
              tickList[7]
              ?
              formatNumUnit(tickList[7][3])
              :
              0.00
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  // eslint-disable-next-line no-unused-vars
  formatNumUnit
} from './js/numberFormat'
export default {
  props: ['mdata', 'code', 'shortname', 'maket'],
  data () {
    return {
      buyLevels: [{ volume: 0, price: 0 }, { volume: 0, price: 0 }, { volume: 0, price: 0 }, { volume: 0, price: 0 }, { volume: 0, price: 0 }],
      sellLevels: [{ volume: 0, price: 0 }, { volume: 0, price: 0 }, { volume: 0, price: 0 }, { volume: 0, price: 0 }, { volume: 0, price: 0 }],
      tickList: [],
      pp: 0, // 昨收价
      symbol: {}, // 代码信息
      upperlimit: 0, // 涨停
      lowerlimit: 0, // 跌停
      buysellPer: '50%' // 委买委卖比

    }
  },
  methods: {
    toRatio (num, digit) {
      if (num == null) {
        return 0.00
      }
      return this.toDecimal(this.numMul(num, 100), digit)
    },
    Color (val1, val2) {
      let num1 = isNaN(Number(val1)) ? 0 : Number(val1)
      let num2 = isNaN(Number(val2)) ? 0 : Number(val2)
      // 判断是否是-0
      if (num1 === 0 && num2 === 0 && (1 / num2 < 0)) {
        return '#20B120'
      }

      if (num1 === 0 && num2 === 0) {
        return '#666'
      }
      if (num1 > num2) {
        return '#20B120'
      } else if (num1 < num2) {
        return '#CC0000'
      } else {
        return '#666'
      }
    }
  },
  created () {

  }
}
</script>

<style lang="less" scoped>
.xflex {
  -webkit-display: flex;
  -khtml-display: flex;
  -moz-display: flex;
  -ms-display: flex;
  display: flex;
}

.xflex-1 {
  -webkit-flex: 1;
  -khtml-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.border1 {
  border: 1px solid red;
}

.xflex-a-c {
  -webkit-align-items: center;
  -khtml-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;

}

.xflex-j-s {
  -webkit-justify-content: space-between;
  -khtml-justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;

}

.xflex-j-c {
  -webkit-justify-content: center;
  -khtml-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}

.xflex-col {
  -webkit-flex-direction: column;
  -khtml-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.t-a-c {
  text-align: center;
}

.color-up {
  color: #CC0000;
}

.color-down {
  color: #20B120;
}

.wdhq-wrapper {
  height: 100%;

  .hq-top-wrapper {
    // height: 500rpx;
    height: 94%;
    font-size: 20rpx;
    border-bottom: 1rpx solid #E5E5E5;
  }

  .hq-top-sell {
    // height: 250rpx;
    height: 50%;
    padding: 10rpx;

    .sell-item {

      // flex: 1;
      .sell-item-text,
      .sell-item-amount {
        color: #999999;
      }

      .sell-item-text {
        width: 56rpx;
      }

      .sell-item-price {
        width: 70rpx;
        padding: 0 6rpx;
        text-align: center;
      }

      .sell-item-amount {
        flex: 1;
        text-align: right;
      }

    }
  }

  .line {
    height: 15rpx;
    background-color: #20B120;
    position: relative;
    margin: 20rpx 0;

    .line1 {
      height: 14rpx;
      position: absolute;
      width: 65%;
      background-color: #CC0000;
      left: 0;
    }
  }

  .hq-bottom-wrapper1 {
    height: 40%;
    font-size: 20rpx;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }

  .hq-bottom-wrapper {
    // height: 376rpx;
    height: 40%;

    .hq-bottom-title {
      height: 60rpx;
      line-height: 60rpx;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      font-size: 24rpx;
    }

    .hq-bottom-item-wrapper {
      height: calc(100% - 60rpx);
      overflow: scroll;

      .hq-bottom-item {
        padding: 0 10rpx;
        font-size: 20rpx;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
        padding: 3rpx 10rpx;

        .hq-bottom-item-time {
          width: 58rpx;
        }

        .hq-bottom-item-price {
          .price {
            // width: 64rpx;
            padding: 0 4rpx;
            text-align: center;
          }

        }

        .hq-bottom-item-amount {
          flex: 1;
          text-align: center;
        }

      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chart/wdhq.vue